import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter } from 'react-router-dom'
import './index.css';
// import App from './containers/App';
import RouterIndex from './pages/RouterIndex';
// import registerServiceWorker from './registerServiceWorker';
import ScrollToTop from './common/ScrollToTop/ScrollToTop';

ReactDOM.render((
   <BrowserRouter>
   <ScrollToTop>
    <RouterIndex />
   </ScrollToTop>
  </BrowserRouter>

), document.getElementById('root'));
// registerServiceWorker();



// WEBPACK FOOTER //
// ./src/index.js